'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { dateIsAfter, dateIsSame } from '@repo/utils/time'

export const LegalAidVersionSelect = ({
  testData = null,
  value = null,
  comparisonDate = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required
}) => {
  const { fetchLegalAidVersions, legalAidVersions } = useLookupsStore()
  const [options, setOptions] = useState(testData || legalAidVersions || [])

  useEffect(() => {
    if (testData) return

    let currentVersionFound = false

    const options =
      legalAidVersions?.map((version) => {
        version.isDisabled = currentVersionFound

        // we want to disable options that pre-date the comparison date, EXCEPT the first date before, which should be the default value
        if (comparisonDate && !currentVersionFound) {
          const versionDate = new Date(version.schemeDate)
          const comparisonDateIsAfterLegalAidVersion =
            dateIsAfter(comparisonDate, versionDate) || dateIsSame(comparisonDate, versionDate)

          // we've found the current version so we can disable options on the next loop iterations
          if (comparisonDateIsAfterLegalAidVersion) {
            currentVersionFound = true

            // if no value is set yet, set the default value to this version
            onChange(version)
          }
        }

        return version
      }) || []

    setOptions(options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, legalAidVersions, comparisonDate])

  useEffect(() => {
    if (testData || legalAidVersions?.length) return
    fetchLegalAidVersions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, legalAidVersions])

  return (
    <div data-testid="LegalAidVersionSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Legal Aid Version"
        onChange={onChange}
        labelKey="description"
        valueKey="schemeId"
        items={options}
        value={value}
        searchable
        idLabelKey="schemeId"
        showIdInResults={false}
        name="legalAidVersion"
        size={size}
        required={required}
      />
    </div>
  )
}

LegalAidVersionSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  comparisonDate: PropTypes.any,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
